import React, { FC } from 'react';

import { TabProps } from './CustomerSites.props';
import SitesTable from './SitesTable';

const ArchivedSites: FC<TabProps> = (props) => (
  <SitesTable {...props} queryScope="archived" archived={1} />
);

export default ArchivedSites;
